<div class="flex w-full h-full">
  <div class="flex flex-col w-1/3 h-full border-0 border-r border-color-light-shade border-solid">
    <div class="w-full h-full flex flex-col gap-4 px-6 py-5 palantir-scrollbar">
      <div class="flex items-center gap-2">
        <palantir-skeleton class="h-10 w-full"></palantir-skeleton>
        <palantir-skeleton class="h-8 w-20"></palantir-skeleton>
      </div>

      <palantir-skeleton class="h-44 w-full"></palantir-skeleton>
      <palantir-skeleton class="h-44 w-full"></palantir-skeleton>
    </div>
  </div>

  <div class="flex flex-col w-2/3 h-full">
    <div
      class="flex items-center justify-start w-full px-6 py-3 h-16 min-h-16 border-0 border-b border-color-light-shade border-solid"
    >
      <palantir-skeleton class="h-6 w-20"></palantir-skeleton>
    </div>

    <div class="w-full h-full flex items-center justify-center px-6 py-5">
      <div
        class="flex flex-col gap-4 px-6 py-5 palantir-scrollbar w-full h-full border border-color-light-shade border-solid rounded-xl"
      >
        @for (i of [].constructor(4); track $index) {
          <div class="flex flex-col gap-4 w-full">
            <palantir-skeleton class="h-5 w-20"></palantir-skeleton>
            <palantir-skeleton class="h-14 w-full"></palantir-skeleton>
          </div>
        }
      </div>
    </div>
  </div>
</div>
